<template>
<div class="background-supplement-no-title-layout">
    <div class="layout-content" v-loading="loading">
        <!-- 日历 -->
        <div class="calendar-area">
            <div class="month-picker">
                <i class="el-icon-arrow-left" style="color:#d7cdcb" @click="switchMonth('prev')"></i>
                <!-- <span class="icon-left-open-2" ></span> -->
                <span class="current-month">{{ currentMonth }}</span>
                <!-- <span class="icon-right-open-2"></span> -->
                <i class="el-icon-arrow-right" style="color:#d7cdcb" @click="switchMonth('next')"></i>
            </div>
            <table class="calendar">
                <thead>
                    <tr>
                        <th v-for="weekday in weekdays" :key="weekday">{{ weekday }}</th>
                    </tr>
                </thead>
                <tbody>
                        <tr v-for="(row, rowIndex) in calendarData" :key="rowIndex">
                            <td v-for="(item, colIndex) in row"
                                :key="`${rowIndex}-${item.date}`"
                                :class="item.scheduleList ? 'schedule-available' : ''"
                                :id="`td-${rowIndex}-${colIndex}`"
                                @click="currentDate = [rowIndex, colIndex]">
                                <div class="date">
                                    <div :class="[item.isToday? 'todayState': '',getDateCssClass(item, rowIndex, colIndex)]">
                                        <div>{{ item.isToday ? '今':item.date }}</div>
                                        <div v-if="item.scheduleList"
                                            class="schedule-tag"
                                            :title="item.scheduleList.length">
                                            {{ item.scheduleList.length }}节
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                </tbody>
            </table>
        </div>
        <!-- 课节计划 -->
        <ScheduleList :current-schedule-list="currentScheduleList"></ScheduleList>
    </div>
    <NoticeDialog :is-show-notice="isShowNotice"></NoticeDialog>
    <PrivacyDialog />
</div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import ScheduleList from './CourseScheduleList';
import NoticeDialog from './NoticeDialog';
import PrivacyDialog from './PrivacyDialog';
import { mapState, mapActions } from 'vuex';

const MONTH_TYPE_CURRENT = 1;
const MONTH_TYPE_OTHER = 2;
const WEEK_LENGTH = 7;

export default {
    components: { ScheduleList, NoticeDialog, PrivacyDialog },
    data() {
        return {
            studentList: [],
            loading: false,
            currentMonth: '',
            calendarData: [],
            weekdays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            // 当前查看计划的位置, 结构为：[行，列]
            currentDate: [],
            isShowNotice: false
        };
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile
        }),
        // 当前展示的课节计划
        currentScheduleList() {
            if (this.currentDate.length !== 2 || !this.calendarData.length) {
                return [];
            }
            return this.calendarData[this.currentDate[0]][this.currentDate[1]].scheduleList || [];
        }
    },
    beforeMount() {
        let currentDate = new Date();
        this.currentMonth = this.normalizeDate(currentDate);
        this.getCalendarData(this.currentMonth);
        this.USER_GET_PROFILE().then((res) => {
            this.isShowNotice = _.get(this.profile, 'notify[0].isNeed', true);
        });
    },
    methods: {
        ...mapActions(['USER_GET_PROFILE']),
        normalizeDate(milliseconds) {
            let d = new Date(milliseconds);
            if (isNaN(d.getTime())) {
                return '';
            }
            let month = d.getMonth() + 1;
            return `${d.getFullYear()}-${month < 10 ? '0' + month : month}`;
        },
        getCalendarData(monthStr) {
            let monthMoment = moment(monthStr);
            if (!monthMoment.isValid()) {
                return [];
            }
            let prependDateList = this.getPaddingDateList(monthMoment.clone().startOf('month'), true);
            let lastDayOfMonth = monthMoment.clone().endOf('month');
            let padDateList = this.getPaddingDateList(lastDayOfMonth, false);
            let currentDateList = this.getCurrentDateList(monthMoment, prependDateList.length);
            let fullDateList = [...prependDateList, ...currentDateList, ...padDateList];
            this.loading = true;
            return this.getTimetable(
                prependDateList.length
                    ? prependDateList[0].momentData.valueOf()
                    : currentDateList[0].momentData.valueOf(),
                padDateList.length
                    ? padDateList[padDateList.length - 1].momentData.clone().endOf('day').valueOf()
                    : currentDateList[currentDateList.length - 1].momentData.clone().endOf('day').valueOf()
            )
                .then(scheduleList => {
                    this.handleScheduleList(scheduleList, fullDateList);
                    this.calendarData = _.chunk(fullDateList, WEEK_LENGTH);
                })
                .catch(err => {
                    this.handleScheduleList([], fullDateList);
                    this.calendarData = _.chunk(fullDateList, WEEK_LENGTH);
                    this.$handleError(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getPaddingDateList(momentObj, isPrepend) {
            let dateArray = [];
            let weekDay = momentObj.day();
            let paddingDayNum = isPrepend
                ? weekDay === 0 ? 6 : weekDay - 1
                : weekDay === 0 ? 0 : WEEK_LENGTH - weekDay;
            if (isPrepend) {
                for (let i = paddingDayNum; i > 0; i--) {
                    let momentData = momentObj.clone().subtract(i, 'days');
                    let isToday = this.checkIfToday(momentData);
                    dateArray.push({
                        date: momentData.date(),
                        type: MONTH_TYPE_OTHER,
                        momentData,
                        isToday
                    });
                }
            } else {
                for (let i = 1; i <= paddingDayNum; i++) {
                    let momentData = momentObj.clone().add(i, 'days');
                    let isToday = this.checkIfToday(momentData);
                    dateArray.push({
                        date: momentData.date(),
                        type: MONTH_TYPE_OTHER,
                        momentData,
                        isToday
                    });
                }
            }
            return dateArray;
        },
        getCurrentDateList(monthMoment, prependDateListLen) {
            let currentDateList = [];
            // 待计算月份的最后一天信息
            let lastDayOfMonth = monthMoment.clone().endOf('month');

            for (let i = 0, len = lastDayOfMonth.date(); i < len; i++) {
                let dayMoment = monthMoment.clone().add(i, 'days');
                let isToday = this.checkIfToday(dayMoment);
                currentDateList.push({
                    date: i + 1,
                    type: MONTH_TYPE_CURRENT,
                    isToday: isToday,
                    momentData: dayMoment
                });
                if (isToday) {
                    let row = parseInt((i + prependDateListLen) / WEEK_LENGTH, 10);
                    let col = (i + prependDateListLen) % WEEK_LENGTH;
                    this.currentDate = [row, col];
                }
            }
            if (monthMoment.month() !== moment().month()) {
                this.currentDate = [0, prependDateListLen];
            }
            return currentDateList;
        },
        checkIfToday(momentObj) {
            let current = new Date();
            let monthCurrent = current.getMonth();
            let dateCurrent = current.getDate();

            return momentObj.month() === monthCurrent && momentObj.date() === dateCurrent;
        },
        switchMonth(action) {
            if (action === 'prev') {
                this.currentMonth = this.normalizeDate(
                    moment(this.currentMonth)
                        .subtract(1, 'months')
                        .valueOf()
                );
            } else {
                this.currentMonth = this.normalizeDate(
                    moment(this.currentMonth)
                        .add(1, 'months')
                        .valueOf()
                );
            }
            this.getCalendarData(this.currentMonth);
        },
        /**
         * startTime: 起始时间，毫秒数值；
         * endTime: 结束时间，毫秒数值；
         * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=56393895#hfsfd-be%E8%AF%BE%E8%8A%82API-%E8%8E%B7%E5%8F%96%E6%88%91%E7%9A%84%E8%AF%BE%E8%A1%A8%E3%80%90WIP%E3%80%91
         */
        getTimetable(startTime, endTime) {
            return this.$http
                .get('/v1/lessons/timetable', { params: { startTime, endTime } })
                .then(resp => this.$checkResp(resp));
        },
        /**
         * augments
         * 预处理课程计划，包括：
         * 1. 安插课程计划到日历里的“scheduleList”字段；
         * 2. 计算startDateStr、endTimeStr
         */
        handleScheduleList(scheduleList, fullDateList) {
            const firstDateTime = fullDateList[0].momentData.valueOf();
            const endDateTime = fullDateList[fullDateList.length - 1].momentData
                .clone()
                .endOf('day')
                .valueOf();
            const millisecondPerDay = 24 * 3600 * 1000;
            scheduleList.forEach(schedule => {
                if (schedule.startTime < firstDateTime || schedule.startTime > endDateTime) {
                    return;
                }
                // 计算startDateStr
                let startTimeStr = moment(schedule.startTime).format('YYYY-MM-DD HH:mm');
                let arr = startTimeStr.split(' ');
                schedule.startDateStr = arr[0];
                schedule.startHourStr = arr[1];
                schedule.endHourStr = moment(schedule.endTime).format('HH:mm');

                let location = parseInt((schedule.startTime - firstDateTime) / millisecondPerDay, 10);
                if (!fullDateList[location].scheduleList) {
                    fullDateList[location].scheduleList = [];
                }
                fullDateList[location].scheduleList.push(schedule);
            });
        },
        getDateCssClass(item, rowIndex, colIndex) {
            let classList = [];
            if (rowIndex === this.currentDate[0] && colIndex === this.currentDate[1] && item.scheduleList) {
                classList.push('today');
            }
            if (item.scheduleList) {
                classList.push('scheduled-date');
            }
            return classList.join(' ');
        }
    }
};
</script>

<style lang="scss" scoped>
.course-schedule {
    background-color: #fff;
    min-height: 560px;
}

.calendar-area {
    position: relative;
}

.calendar-area {
    .month-picker {
        height: 90px;
        line-height: 90px;
        text-align: center;
        font-size: 20px;

        .current-month {
            margin: 0 20px;
        }

        .icon-left-open-2,
        .icon-right-open-2 {
            color: #d1d5dd;
            cursor: pointer;
        }
    }

    .calendar {
        border-collapse: collapse;
        width: 100%;
        $borderColor: #eee;

        th {
            // background-color: #fafafa;
            // border: 1px solid $borderColor;
            height: 40px;
            vertical-align: middle;
            color: black;
        }

        td {
            // border: 1px solid $borderColor;
            width: 134px;
            vertical-align: middle;
            text-align: center;
            color: #4d4d4d;
        }

        .schedule-available {
            position: relative;

            .schedule-tag {
                line-height: 19px;
                text-align: center;
                color: #f4664b;
                font-size: 12px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }

        $todayColor: #f4664b;

        .date {
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            // padding-top: 12px;
        }

        .scheduled-date {
            cursor: pointer;
        }

        .active {
            // background-color: $todayColor;
        }

        .todayState {
            color: $todayColor;
        }

        .today {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            flex-direction: column;
            // line-height: 20px;
            border-radius: 50%;
            text-align: center;
            color: #fff;
            background-color: $todayColor;
            position: relative;
            // top: 0;
            margin: 0 auto;
            // padding: 5px;
            .schedule-tag {
                color: #fff;
            }
        }

        .today-str {
            color: $todayColor;
            margin-top: 10px;
            position: relative;
            top: 5px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/index/components/CourseSchedule.vue